import { WeaTools } from 'ecCom'

export const hasRight = () => {
    return  WeaTools.callApi('/api/hrm/resource/add/hasRight','GET');
}

export const getSearchCondition = () => {
    return  WeaTools.callApi('/api/hrm/search/getHrmSearchCondition','GET');
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/search/getHrmSearchResult', 'POST', params);
}

export const getHrmResourceAddForm = (params={}) => {
    return WeaTools.callApi('/api/hrm/resource/add/getHrmResourceAddForm', 'GET', params)
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/add.js